.praksistypekodePadding {
  display: inline-block;
  min-width: 12ch;
}

.praksistypekodeNavn {
  display: inline-block;
}
